import { render, staticRenderFns } from "./CentersCrudContacts.vue?vue&type=template&id=03c0fa3c&"
import script from "./CentersCrudContacts.vue?vue&type=script&lang=js&"
export * from "./CentersCrudContacts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports